<template>
  <section class="login-2">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper p-0">
        <div
          class="content-wrapper d-flex align-items-stretch auth auth-img-bg"
          style="overflow: hidden"
        >
          <div class="row flex-grow">
            <div class="col-lg-5 login-form-left d-flex align-items-center justify-content-center">
              <div class="brand-logo auth-form-transparent col-md-12 col-lg-9">
                <img :src="require('@/assets/images/logo3.png')" alt="logo" />
              </div>
              <div class="width-form pt-5 pt-lg-0 mt-md-5 mb-md-3 mb-lg-0 mt-lg-0">
                <div class="auth-form-transparent text-left pt-5 pt-md-0 px-0 col-md-12 col-lg-9">
                  <div>
                    <h3 class="mb-3">{{ $t('login.entry') }}</h3>
                    <h5 class="font-weight-light mb-4 custom-size-16">
                      {{ $t('login.gladToSeeYouAgain') }}
                    </h5>
                  </div>

                  <b-alert v-model="isError" variant="danger">{{ error }}</b-alert>

                  <smart-oee-login-form></smart-oee-login-form>
                  <div class="mt-4 text-center font-weight-light mb-3 mb-md-0">
                    {{ $t('login.form.footer.accountMsg') }}
                    <router-link :to="{ name: 'SmartOeeRegister' }" class="text-primary">
                      {{ $t('login.form.footer.registerLink') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-7 col-md-12 login-half-bg d-flex align-items-center justify-content-center"
            >
              <text-for-login-register-page></text-for-login-register-page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SmartOeeLogin',
  computed: {
    date() {
      return new Date().getFullYear();
    },
    isError() {
      return !!this.$store.getters.getError;
    },
    error() {
      return this.$store.getters.getError;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form-left {
  position: relative;
  background-color: #191c24;
  .brand-logo {
    position: absolute;
    top: 35px;
  }
}
.custom-size-40 {
  font-size: 40px;
}
.custom-size-16 {
  font-size: 16px;
}
@media (min-width: 768px) {
  .width-form {
    width: 100%;
  }
}
@media (max-width: 767.9px) {
  .login-form-left {
    .brand-logo {
      left: 10%;
    }
  }
  .width-form {
    width: 75%;
  }
}
</style>
